import { render, staticRenderFns } from "./HelpTab.vue?vue&type=template&id=222a8afc&"
import script from "./HelpTab.vue?vue&type=script&lang=js&"
export * from "./HelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports